import {useQuery} from '@github-ui/react-query'

import type {CopilotChatRepo} from '../utils/copilot-chat-types'
import {useChatManager} from '../utils/CopilotChatManagerContext'
import {useFilterQuery} from './use-filter-query'

export function useRepositoryFilesQuery(repository: CopilotChatRepo | null, searchQuery: string) {
  const manager = useChatManager()

  const query = useQuery({
    enabled: repository !== null,
    queryKey: ['copilot-repository-files', repository],
    queryFn: async () => {
      if (!repository) return {}

      const response = await manager.service.listRepoFiles(repository, true)

      if (!response.ok) throw new Error('Failed to fetch files for repository')

      return response.payload
    },
  })

  const filteredPathsQuery = useFilterQuery(query.data?.paths ?? null, searchQuery)
  const filteredDirectoriesQuery = useFilterQuery(query.data?.directories ?? null, searchQuery)

  return {
    query,
    filteredPathsQuery,
    filteredDirectoriesQuery,
  }
}
